<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@media (min-width: 1024px){
     body{font-size: 18px}
     } /*>=1024的设备*/

     @media (min-width: 1100px) {
     body{font-size: 20px}
     } /*>=1100的设备*/
     @media (min-width: 1280px) {
     body{font-size: 22px;}
     } /*>=1280的设备*/

     @media (min-width: 1366px) {

     body{font-size: 24px;}
     }

     @media (min-width: 1440px) {
     body{font-size: 25px !important;}
     }

     @media (min-width: 1680px) {
     body{font-size: 28px;}
     }
     @media (min-width: 1920px) {
     body{font-size: 33px;}
     }
  body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td { margin:0; padding:0; }
  body, button, input, select, textarea { font:12px/1.5tahoma, arial, \5b8b\4f53; }
  h1, h2, h3, h4, h5, h6{ font-size:100%; }
  address, cite, dfn, em, var { font-style:normal; }
  code, kbd, pre, samp { font-family:couriernew, courier, monospace; }
  small{ font-size:12px; }
  ul, ol { list-style:none; }
  a { text-decoration:none; }
  a:hover { text-decoration:underline; }
  sup { vertical-align:text-top; }
  sub{ vertical-align:text-bottom; }
  legend { color:#000; }
  fieldset, img { border:0; }
  button, input, select, textarea { font-size:100%; }
  table { border-collapse:collapse; border-spacing:0; }
  #app {

  }
</style>



// WEBPACK FOOTER //
// src/App.vue